var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconcredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 1.66675C5.39758 1.66675 1.66675 5.39758 1.66675 10.0001C1.66675 14.6026 5.39758 18.3334 10.0001 18.3334C14.6026 18.3334 18.3334 14.6026 18.3334 10.0001C18.3334 5.39758 14.6026 1.66675 10.0001 1.66675ZM10.0001 2.50008C10.0001 4.48921 9.20991 6.39686 7.80338 7.80338C6.39686 9.20991 4.48921 10.0001 2.50008 10.0001C4.48921 10.0001 6.39686 10.7903 7.80338 12.1968C9.20991 13.6033 10.0001 15.511 10.0001 17.5001C10.0001 15.511 10.7903 13.6033 12.1968 12.1968C13.6033 10.7903 15.511 10.0001 17.5001 10.0001C15.511 10.0001 13.6033 9.20991 12.1968 7.80338C10.7903 6.39686 10.0001 4.48921 10.0001 2.50008Z",
    fill: "url(#paint0_linear_54876_6160)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54876_6160",
    x1: 10.0001,
    y1: 1.66675,
    x2: 10.0001,
    y2: 18.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#899BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6135FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconcredit);
export default __webpack_public_path__ + "static/media/icon.credit.6281244c99dc09119f72aff2b5aeba05.svg";
export { ForwardRef as ReactComponent };